import { API_CALL } from '../../../middleware/api';

export const GET_ORG_SAML_PROVIDER = 'GET_ORG_SAML_PROVIDER';
export const GET_ORG_SAML_PROVIDER_RESULT = `${GET_ORG_SAML_PROVIDER}/result`;
export const GET_ORG_SAML_PROVIDER_ERROR = `${GET_ORG_SAML_PROVIDER}/error`;

export const GET_ORG_SAML_SERVICE_PROVIDER = 'GET_ORG_SAML_SERVICE_PROVIDER';
export const GET_ORG_SAML_SERVICE_PROVIDER_RESULT = `${GET_ORG_SAML_SERVICE_PROVIDER}/result`;
export const GET_ORG_SAML_SERVICE_PROVIDER_ERROR = `${GET_ORG_SAML_SERVICE_PROVIDER}/error`;

export const SET_ORG_SAML_PROVIDER = 'SET_ORG_SAML_PROVIDER';
export const SET_ORG_SAML_PROVIDER_RESULT = `${SET_ORG_SAML_PROVIDER}/result`;
export const SET_ORG_SAML_PROVIDER_ERROR = `${SET_ORG_SAML_PROVIDER}/error`;

export const DELETE_ORG_SAML_PROVIDER = 'DELETE_ORG_SAML_PROVIDER';
export const DELETE_ORG_SAML_PROVIDER_RESULT = `${DELETE_ORG_SAML_PROVIDER}/result`;
export const DELETE_ORG_SAML_PROVIDER_ERROR = `${DELETE_ORG_SAML_PROVIDER}/error`;

export const actions = {
  getOrgSamlProvider: orgUuid => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/organizations/${orgUuid}/saml-provider`,
    },
    type: GET_ORG_SAML_PROVIDER,
  }),

  getOrgSamlServiceProvider: orgUuid => ({
    [API_CALL]: {
      method: 'GET',
      endpoint: `portal/v1/superadmin/admin/organizations/${orgUuid}/saml-provider/service-provider`,
    },
    type: GET_ORG_SAML_SERVICE_PROVIDER,
  }),

  setOrgSamlProvider: (orgUuid, configuration) => ({
    [API_CALL]: {
      method: 'PUT',
      endpoint: `portal/v1/superadmin/admin/organizations/${orgUuid}/saml-provider`,
      data: configuration,
    },
    type: SET_ORG_SAML_PROVIDER,
  }),

  deleteOrgSamlProvider: orgUuid => ({
    [API_CALL]: {
      method: 'DELETE',
      endpoint: `portal/v1/superadmin/admin/organizations/${orgUuid}/saml-provider`,
    },
    type: DELETE_ORG_SAML_PROVIDER,
  }),
};
